<template>
  <div id="publicClass_success">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <div class="hotgkt_bj">
      <div class="order_Steps">
        <div class="ul">
          <div class="stepsT">
            <strong
              ><span class="left"></span><span class="right"></span
            ></strong>
          </div>
          <div class="li" :class="{ side: side1 }">订单确认</div>
          <div class="li" :class="{ side: side2 }">订单支付</div>
          <div class="li" :class="{ side: side3 }">购买成功</div>
        </div>
      </div>
      <!-- order_Steps end -->
      <div class="order_content">
        <div class="order_xx">
          <div class="p1">
            <img src="../../assets/publicClass/pay_success.png" width="120" />
          </div>
          <div class="p2">恭喜您已购买成功！</div>
          <div class="p3">付款金额:￥{{ dataText }}</div>
          <div class="p4">
            <strong>您想继续做：</strong>
            <router-link :to="{ path: '/personalCentre/myCourses' }"
              >查看订单</router-link
            >
            <router-link :to="{ path: '/personalCentre/myMission' }"
              >我的课程</router-link
            >
            <router-link :to="{ path: '/course_list' }">继续购买</router-link>
          </div>
        </div>
      </div>
      <!-- order_content end -->
      <div class="Select_class">
        <div class="title" v-if="ChoiceClassCourse.length > 0">
          <i></i>{{ Title
          }}<span @click="allcourse" v-if="ChoiceClassCourse.length > 1"
            >选择课程</span
          >
        </div>
        <div class="select_content" v-if="CourseClasses.length > 0">
          <h2>
            选择班级<span>共{{ CourseClasses.length }}个班级</span>
          </h2>
          <div class="theClass">
            <ul class="clearfix">
              <li
                class="theClass_li"
                v-for="(item, index) in CourseClasses"
                tabindex="index"
              >
                <h3>{{ item.Title }}</h3>
                <p>
                  计划开班时间：{{ item.PlanOpenDate }}<br />
                  上课时间：{{ item.Describe }}
                </p>
                <div class="tc clearfix">
                  <strong>
                    <img :src="item.Staffs[0].HeadUrl" />
                  </strong>
                  <span>{{ item.Staffs[0].Name }}</span>
                  <!-- <div v-if="item.IsApply"> -->
                  <p
                    v-if="!item.IsApply && item.RegisterStatus != 2"
                    @click="addCourse(index)"
                  >
                    加入该班级
                  </p>
                  <p class="side" v-else-if="item.RegisterStatus == 2">
                    班级已满员
                  </p>
                  <p v-else>已加入该班级</p>
                </div>
              </li>
            </ul>

            <el-form ref="Submitform" :model="Submitform" label-width="80px">
              <el-form-item label="暂不选择">
                <el-col :span="6">
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="Submitform.date1"
                    style="width: 100%;"
                  >
                  </el-date-picker>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="17">
                  <el-button @click="onSubmit" type="danger" round
                    >提醒我选班</el-button
                  >
                </el-col>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- Select_class end -->
      <div class="tip">
        <p>
          直播课不支持Windows xp和Mac OS10.11以下版本，需要升级电脑系统后上课！
        </p>
        <router-link
          :to="{ path: '/downloads', query: { nav: 7 } }"
          tag="a"
          target="_blank"
          >下载APP 上课更便捷</router-link
        >
      </div>
      <!-- tip end -->
    </div>
    <!-- hotgkt_bj end -->
    <div class="Select_tan" v-if="Select_tan">
      <div class="close2" @click="closePay">
        <img src="../../assets/login/close.png" />
      </div>
      <h2>选择课程</h2>
      <el-form ref="Selectform">
        <el-form-item class="courseli">
          <el-radio-group v-model="Selectform">
            <el-radio
              v-for="(item, index) in ChoiceClassCourse"
              :key="item.Id"
              :label="item.Title"
              @change="ChoiceIdFunc(index)"
            ></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSelect" round>确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部
export default {
  name: "App",
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header
  },
  data() {
    return {
      tokenkey: "",
      Title: "",
      side1: true,
      side2: true,
      side3: true,
      checked: false,
      radio: "",
      radio1: "",
      radio2: "",
      pay_tan: false,
      dataText: "",
      theClassli: "",
      Submitform: {
        date1: ""
      },
      Select_tan: false,
      Selectform: {
        course: ""
      },
      CourseClasses: [], //下设班级
      ChoiceClassCourse: [],
      ChoiceId: ""
    };
  },
  methods: {
    onSubmit() {
      // console.log(this.Submitform);
    },
    ChoiceIdFunc(index) {
      this.ChoiceId = this.ChoiceClassCourse[index].Id;
      this.titles = this.ChoiceClassCourse[index].Title;
    },
    onSelect(a) {
      let that = this;
      that.Select_tan = false;
      let CourseId = localStorage.getItem("Ids");
      that.Title = that.titles; //切换标题
      // 如果没选课程
      if (that.ChoiceId == "") {
        return;
      } else {
        that.download(that.ChoiceId); //刷新按钮状态
      }
    },
    allcourse() {
      this.Select_tan = true;
    },
    closePay() {
      this.Select_tan = false;
    },
    //加入该班级
    addCourse(a) {
      let that = this;
      let CourseId = that.CourseClasses[a].CourseId;
      that.ClassId = that.CourseClasses[a].Id;
      // console.log(CourseId, that.ClassId)
      this.$http
        .post(
          "https://schoolapi.eiceducation.com.cn/api/ChoiceClass",
          {
            CourseId: CourseId,
            ClassId: that.ClassId
          },
          {
            headers: {
              "content-type": "application/json; charset=utf-8",
              token: that.tokenkey
            }
          }
        )
        .then(function(result) {
          // console.log(result)
          //还未购买
          if (result.data.code == 2) {
            that.$message.warning(result.data.msg);
          } else if (result.data.code == 7) {
            that.$message.warning(result.data.msg);
          } else {
            // 已加入该班级
            that.$message.success(result.data.msg);
          }
          that.download(that.Ids); //刷新按钮状态
          //提示已预约
          // that.$message.error(result.data.msg);
        })
        .catch(function(error) {
          // console.log(error);
        });
    },
    download(Ids) {
      let that = this;
      // 下设班级
      that.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/CourseClass?courseId=" +
            Ids,
          {
            headers: {
              "content-type": "application/json; charset=utf-8",
              token: that.tokenkey
            }
          }
        )
        .then(function(response) {
          // console.log(response.data.results)
          that.CourseClasses = response.data.results;
          that.ChoiceIdAll = response.data.results;
          that.RegisterStatus = response.data.results.RegisterStatus; //班级状态（报名状态 0未展示、1展示、2满班 ,）
        })
        .catch(function(err) {
          // console.log(err);
          // console.log('数据错误');
        });
    }
  },
  mounted: function() {
    //自动触发写入的函数
    let that = this;
    if (!this.$cookies.isKey("token")) {
      this.$router.push("/index");
    }
    that.tokenkey = that.$cookies.get("token");
    that.dataText = JSON.parse(localStorage.getItem("Money"));
    that.Title = localStorage.getItem("Title");
    const Orders = localStorage.getItem("Orders"); //获取订单
    // console.log(Orders)
    that.$http
      .get(
        "https://schoolapi.eiceducation.com.cn/api/OrderCallBack?orderNum=" +
          Orders +
          "&type=1",
        {
          headers: {
            "content-type": "application/json; charset=utf-8",
            token: that.tokenkey
          }
        }
      )
      .then(function(result) {
        // console.log(result.data.results.Courses);
        that.ChoiceClassCourse = result.data.results.Courses;
        that.Title = that.ChoiceClassCourse[0].Title;
        that.Ids = result.data.results.Courses[0].Id; //默认显示第一个课程的班级
        that.download(that.Ids);
      })
      .catch(function(error) {
        // console.log(error);
      });
  }
};
</script>

<style scoped>
a {
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.hotgkt_bj {
  background: #fafafa;
  padding-top: 20px;
  padding-bottom: 110px;
}

.order_Steps {
  width: 1180px;
  height: 120px;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 auto;
  margin-bottom: 16px;
}

.order_Steps .ul {
  width: 658px;
  height: 77px;
  padding-top: 22px;
  margin: 0 auto;
  display: -webkit-flex;
  justify-content: space-between;
  display: flex;
  position: relative;
}

.order_Steps .ul .li {
  display: inline-block;
  width: 110px;
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  color: #999999;
  background: url(../../assets/publicClass/icon_JD-B.png) top no-repeat;
  text-align: center;
  padding-top: 61px;
  position: relative;
  z-index: 5;
}

.order_Steps .ul .li.side {
  background-image: url(../../assets/publicClass/icon_JD-A.png);
  color: #333333;
}

.order_Steps .ul .stepsT {
  width: 600px;
  height: 5px;
  background: #f6f6f6;
  border-radius: 3px;
  position: absolute;
  left: 29px;
  top: 65px;
  padding-top: 1px;
}

.order_Steps .ul .stepsT strong {
  display: block;
  width: 600px;
  height: 4px;
  background: #ff7e7e;
  border-radius: 3px;
}

.order_Steps .ul .stepsT strong span {
  width: 6px;
  height: 6px;
  background: #ff7e7e;
  border-radius: 3px;
  margin-top: -1px;
}

.order_Steps .ul .stepsT strong .left {
  margin-left: -1px;
}

.order_content {
  width: 1180px;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 auto;
}

.order_xx {
  width: 1080px;
  padding-top: 50px;
  padding-bottom: 90px;
  margin: 0 auto;
  text-align: center;
}

.order_xx .p1 {
  margin-bottom: 32px;
}

.order_xx .p2 {
  font-size: 14px;
  color: #333;
  line-height: 14px;
  margin-bottom: 16px;
}

.order_xx .p3 {
  font-size: 16px;
  color: #666;
  line-height: 16px;
  margin-bottom: 66px;
}

.order_xx .p4 {
  text-align: center;
}

.order_xx .p4 strong {
  display: inline-block;
  line-height: 28px;
  color: #999;
  margin: 0 6px;
  font-size: 16px;
  font-weight: normal;
}

.order_xx .p4 a {
  display: inline-block;
  width: 124px;
  height: 28px;
  background: rgba(248, 248, 248, 1);
  border-radius: 14px;
  line-height: 28px;
  color: #666;
  margin: 0 6px;
  font-size: 16px;
  cursor: pointer;
}

.order_xx .p4 a:hover {
  background: rgba(230, 230, 230, 1);
}

.tip {
  width: 1180px;
  margin: 0 auto;
  text-align: right;
}

.tip p {
  display: block;
  font-size: 14px;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
}

.tip a {
  display: inline-block;
  width: 176px;
  height: 36px;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #979797;
  font-size: 14px;
  color: #333333;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}

.tip a:hover {
  color: #ffffff;
  background: linear-gradient(90deg, #7782fb 0%, #4e5cf6 100%);
  opacity: 0.9;
}

.Select_class {
  width: 1180px;
  margin: 0 auto;
}

.Select_class .title {
  padding: 0 48px;
  padding-top: 17px;
  padding-bottom: 15px;
  background: url(../../assets/shopping/shop_ico1.png) 17px no-repeat;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
  text-align: left;
}

.Select_class .title span {
  float: right;
  font-size: 16px;
  cursor: pointer;
}

.select_content {
  width: 1084px;
  padding: 0 48px;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 auto;
  padding-bottom: 43px;
  text-align: left;
}

.select_content h2 {
  font-size: 18px;
  color: #666666;
  line-height: 28px;
  padding-top: 20px;
  padding-bottom: 10px;
  border-bottom: 1px #d5d5d5 solid;
  font-weight: normal;
  text-align: left;
  margin-bottom: 18px;
}

.select_content h2 span {
  float: right;
}

/* .select_content .theClass ul {
    padding-bottom: 30px;
  }

  .select_content .theClass ul li {
    border-bottom: 1px #D5D5D5 solid;
    padding-bottom: 18px;
    margin-bottom: 18px;
    text-align: left;
  }

  .select_content .theClass ul li h3 {
    font-size: 20px;
    color: #333333;
    line-height: 30px;
    font-weight: normal;
    margin-bottom: 10px;
  }

  .select_content .theClass ul li p {
    font-size: 16px;
    color: #666666;
    line-height: 24px;
    margin-bottom: 12px;
    display: block;
    width: 120px;
    height: 34px;
    background: #FFFFFF;
    border-radius: 18px;
    border: 1px solid #D5D5D5;
    line-height: 34px;
    text-align: center;
    font-size: 16px;
    color: #333;
    float: right;
    transition: all .25s ease-in;
    -moz-transition: all .25s ease-in;
    -webkit-transition: all .25s ease-in;

  }

  .select_content .theClass ul li .tc strong {
    display: block;
    border: 2px #F5F6F6 solid;
    width: 35px;
    height: 35px;
    overflow: hidden;
    float: left;
    border-radius: 18px;
    margin-right: 8px;
    margin-top: 2px;
    background: url(../../assets/courselist/morimg.png) center no-repeat;
    background-size: 100% auto;
  }

  .select_content .theClass ul li .tc strong img {
    width: 100%
  }

  .select_content .theClass ul li .tc span {
    display: block;
    line-height: 39px;
    font-size: 16px;
    color: #333;
    float: left;
  }

  .select_content .theClass ul li .tc a {
    display: block;
    width: 120px;
    height: 34px;
    background: #FFFFFF;
    border-radius: 18px;
    border: 1px solid #D5D5D5;
    line-height: 34px;
    text-align: center;
    font-size: 16px;
    color: #333;
    float: right;
    transition: all .25s ease-in;
    -moz-transition: all .25s ease-in;
    -webkit-transition: all .25s ease-in;
  }

  .select_content .theClass ul li .tc a:hover {
    color: #fff;
    background: #4E5CF6;
    border-color: #4E5CF6;
  } */

.theClass ul li {
  border-bottom: 1px #d5d5d5 solid;
  padding-bottom: 12px;
  margin-bottom: 16px;
  text-align: left;
}

.theClass ul li h3 {
  font-size: 20px;
  color: #333333;
  line-height: 30px;
  font-weight: normal;
}

.theClass ul li p {
  font-size: 16px;
  color: #666666;
  line-height: 24px;
  margin-bottom: 8px;
}

.theClass ul li .tc strong {
  display: block;
  border: 2px #f5f6f6 solid;
  width: 28px;
  height: 28px;
  overflow: hidden;
  float: left;
  border-radius: 16px;
  margin-right: 8px;
  margin-top: 2px;
  background: url(../../assets/courselist/morimg.png) center no-repeat;
  background-size: 100% auto;
}

.theClass ul li .tc strong img {
  width: 100%;
}

.theClass ul li .tc span {
  display: block;
  line-height: 36px;
  font-size: 16px;
  color: #333;
  float: left;
}

.theClass ul li .tc p {
  display: block;
  width: 120px;
  height: 34px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid #d5d5d5;
  line-height: 34px;
  text-align: center;
  font-size: 16px;
  color: #333;
  float: right;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.theClass ul li .tc p:hover {
  color: #fff;
  background: #4e5cf6;
  border-color: #4e5cf6;
  cursor: pointer;
}

.theClass ul li .tc p.side {
  color: #fff;
  background: #4e5cf6;
  border-color: #4e5cf6;
  cursor: pointer;
}

.Select_tan {
  width: 402px;
  height: 560px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(102, 102, 102, 0.6);
  border-radius: 12px;
  position: fixed;
  top: 20%;
  left: 50%;
  margin-left: -230px;
  padding: 0 29px;
  text-align: left;
  z-index: 100;
}

.Select_tan .close2 {
  width: 36px;
  height: 36px;
  position: absolute;
  left: 20px;
  top: 20px;
  cursor: pointer;
}

.Select_tan h2 {
  font-size: 20px;
  color: #333;
  line-height: 30px;
  padding-top: 57px;
  padding-bottom: 22px;
  font-weight: 500;
  text-align: center;
}

.Select_tan .courseli {
  font-size: 16px;
  line-height: 20px;
}

/deep/ .Select_tan .el-radio-group {
  max-height: 350px;
  height: 350px;
  text-align: left;
  overflow-y: scroll;
  width: 410px;
}

/deep/ .Select_tan .el-radio {
  display: block;
  margin-bottom: 20px;
}

/deep/ .Select_tan .el-radio__label {
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 20px;
  vertical-align: middle;
  display: inline-block;
}

/deep/ .Select_tan .el-form-item__content {
  text-align: center;
}

/deep/ .Select_tan .el-form-item__content button {
  width: 160px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/page2/courseList/course_success.vue